export const normalizeRequisitionStatus = (status) => {
  const rawStatus = String(status || '').trim().toLowerCase();

  if (!rawStatus || rawStatus === 'pending') {
    return 'Pending Approval';
  }

  if (rawStatus === 'pending approval') {
    return 'Pending Approval';
  }

  if (rawStatus === 'partialy approved' || rawStatus === 'partially approved') {
    return 'Partially Approved';
  }

  if (rawStatus === 'approved') {
    return 'Approved';
  }

  if (rawStatus === 'rejected') {
    return 'Rejected';
  }

  if (rawStatus === 'on hold') {
    return 'On Hold';
  }

  if (rawStatus === 'review' || rawStatus === 'needs review') {
    return 'Review';
  }

  return status;
};

export const getRequisitionStatusTone = (status) => {
  const normalizedStatus = normalizeRequisitionStatus(status);

  if (normalizedStatus === 'Approved') {
    return 'approved';
  }

  if (normalizedStatus === 'Rejected') {
    return 'rejected';
  }

  if (normalizedStatus === 'Partially Approved') {
    return 'partial';
  }

  if (normalizedStatus === 'On Hold') {
    return 'hold';
  }

  if (normalizedStatus === 'Review') {
    return 'review';
  }

  return 'pending';
};

export const formatRequisitionCurrency = (amount) => {
  const numericAmount = Number(amount);
  return `KES ${Number.isFinite(numericAmount) ? numericAmount.toLocaleString() : '0'}`;
};

export const toDateValue = (value) => {
  if (!value) {
    return null;
  }

  if (value instanceof Date) {
    return value;
  }

  if (typeof value?.toDate === 'function') {
    return value.toDate();
  }

  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const formatRequisitionDate = (value, fallback = 'Not set') => {
  const dateValue = toDateValue(value);

  if (!dateValue) {
    return fallback;
  }

  return dateValue.toLocaleString('en-KE', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit'
  });
};
